export default "__VITE_ASSET__W3glDL6___"